import { Link } from 'react-router-dom';

import { appConfig } from '../config/appConfig';

export function IcpFooter() {
  return (
    <footer className="border-t border-border bg-surface px-4 py-6 text-center text-sm text-muted">
      <p>
        © {new Date().getFullYear()} {appConfig.appName}
        {' · '}
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-primary"
        >
          {appConfig.icpWebsite}
        </a>
      </p>
      <p className="mt-2">
        <Link to="/download?view=1" className="hover:text-primary">下载 App</Link>
        {' · '}
        <Link to="/privacy" className="hover:text-primary">隐私政策</Link>
        {' · '}
        <Link to="/terms" className="hover:text-primary">用户协议</Link>
        {' · '}
        <Link to="/copyright" className="hover:text-primary">版权声明</Link>
        {' · '}
        <Link to="/support" className="hover:text-primary">联系我们</Link>
        {' · '}
        <Link to="/about" className="hover:text-primary">关于</Link>
      </p>
    </footer>
  );
}
